import React from "react";

const FiltersBar: React.FC = () => {
    return (
        <div className="bg-[#e6edf8] max-w-[1200px] mx-auto pt-2 pb-4">
            <div>
                <div className="flex items-center justify-between">
                    {/* Left side - Lowest fare tag */}
                    <div className="flex items-center gap-2">
                        <div className="">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="#d6992e"
                            >
                                <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
                            </svg>
                        </div>
                        <span className="text-[#0047ba] text-base">
                            Lowest fare
                        </span>
                    </div>

                    {/* Right side - Filters and Sort */}
                    <div className="flex items-center gap-12">
                        {/* Filters button */}
                        <button className="flex items-center gap-2 text-[#0047ba] text-base hover:opacity-80 transition-opacity">
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Filters
                        </button>

                        {/* Sort dropdown */}
                        <div className="relative">
                            <button className="flex items-center gap-2 text-gray-700 text-sm hover:text-gray-900 transition-colors">
                                <span>Sort by:</span>
                                <span className="text-base text-[#0047ba]">
                                    Most relevant
                                </span>
                                <svg
                                    className="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FiltersBar;
